import { faAsterisk } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useRef, useState } from "react";
import { FloatingLabel, Form, OverlayTrigger, Stack, Tooltip } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

interface InputPhoneState {
  label: string;
  value: any;
  onUpdate: any;
  disabled?: any;
  readOnly?: boolean;
  required?: boolean;
  css?: string;
}

const InputPhone = ({ label, value, onUpdate, disabled, readOnly = false, required = false, css = "" }: InputPhoneState) => {
  const formatPhone = (val: string): string => {
    const digits = val.replace(/\D/g, "").slice(0, 11);
    if (digits.length < 11) return "";
    return `${digits.slice(0, 1)} (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
  };

  return (
    <>
      {readOnly ? (
        <FloatingLabel controlId="floatingInput" label={<span className={"app-orange-text fw-bold mb-3"}>{label}</span>}>
          <Form.Control
            type={"text"}
            placeholder={label}
            value={value ? formatPhone(value) : ""}
            onChange={onUpdate}
            disabled={disabled}
            readOnly={readOnly}
            className={css + " form-control-readonly"}
          />
        </FloatingLabel>
      ) : (
        <Stack direction="horizontal" className={css}>
          <OverlayTrigger placement="top" delay={{ show: 150, hide: 250 }} overlay={!readOnly ? <Tooltip>Required</Tooltip> : <></>}>
            <PhoneInput
              countryCodeEditable={false}
              country={"us"}
              onlyCountries={["us"]}
              disableDropdown={true}
              placeholder={label}
              value={value}
              onChange={onUpdate}
              disabled={disabled}
              inputProps={{ readOnly: readOnly }}
              containerClass={readOnly ? "form-floating-readonly" : "form-floating-enabled"}
              inputClass={`phone-input w-100 ${readOnly ? "form-control-readonly" : "form-control-enabled"}`}
            />
          </OverlayTrigger>
          {required && (
            <FontAwesomeIcon
              className="app-tertiary-color-inverse"
              icon={faAsterisk}
              style={{
                position: "relative",
                right: 15,
                top: -20,
                zIndex: 1,
                fontSize: 11,
              }}
            />
          )}
        </Stack>
      )}
    </>
  );
};

export default InputPhone;
